import URL from '../constants/url';

export default async() => {
  const response = await fetch(`${URL}/colors?_sort=name:asc&_limit=0`)
        .catch(error=> console.error(error));

  const colors = await response.json();
  if(colors.error){
    return null
  }

  return colors;
}
